/** 월 단위 조회 범위·이동 — app.ts에서 추출. */

/** "YYYY-MM" → 1일~말일. 형식이 다르면 null. */
export function monthRange(yearMonth: string): { from: string; to: string } | null {
  if (!/^\d{4}-\d{2}$/.test(yearMonth)) {
    return null;
  }
  const [year, month] = yearMonth.split("-").map(Number);
  const lastDay = new Date(year, month, 0).getDate();
  return { from: `${yearMonth}-01`, to: `${yearMonth}-${String(lastDay).padStart(2, "0")}` };
}

/** "YYYY-MM"에 delta개월 가감 (연 롤오버 포함). */
export function shiftMonth(yearMonth: string, delta: number): string {
  const [year, month] = yearMonth.split("-").map(Number);
  const d = new Date(year, month - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}
